module.exports = __webpack_public_path__ + "static/img/plan.c128677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan.png
// module id = wEbZ
// module chunks = 1